import {
	GetAccessManagementPermissionsParams,
	GetAccessManagementPermissionsResponse,
} from 'domain/usecases';
import {makeGetAccessManagementPermissions} from 'main/factories/usecases';

export async function getAccessManagementPermissions(
	params: GetAccessManagementPermissionsParams,
): Promise<GetAccessManagementPermissionsResponse> {
	return makeGetAccessManagementPermissions().get(params);
}
